import { BaseConfiguration } from './base-configuration.model';
import { ReferenceSystem } from './reference-system.enum';

export class AssemblyConfiguration extends BaseConfiguration {
  totalNumberOfIncrements: number;
  analysisStep: number;
  stepsForDeformedGeometryGeneration: number;

  constructor() {
    super();
    this.displacementAndRotationNorm = true;
    this.maximumUnbalancedForce = true;
    this.forceAndMomentumNorm = true;
    this.maximumUnbalancedMoment = false;
    this.totalNumberOfIncrements = 11;
    this.analysisStep = 1;
    this.stepsForDeformedGeometryGeneration = 1;
    this.maxNumberOfIterations = 20;
    this.convergenceErrorTolerance = 0.001;
    this.maxUnbalancedForce = 1;
    this.maxUnbalancedMoment = 1;
    this.referenceSystem = ReferenceSystem.GLOBAL;
  }
}
